import React, { Component } from "react";
import debounce from "lodash.debounce";
import { connect } from "react-redux";
import _ from "i18n";
import { selectLoggedAs } from "Selectors";
import {
  initFilterClient,
  setFilterBusinessUnit,
  setFilterClient,
  setFilterClientGroup,
  setFilterCluster,
  setClientCRMGroup,
  setFilterCollaborators,
  setFilterSquads,
  setFilterYear,
  setClientType,
  setClientCRMType,
  setFinancialSortBy,
  setFinancialSheetTreeSearchWord,
  setClientsDeletedStatus,
  setIsEntityClientsState,
  setRole,
  setPartner,
  setPartnerZone
} from "Actions";
import {
  fetchBusinessUnitSuggestions,
  // fetchClientSuggestions,
  fetchClusterSuggestions,
  fetchCollaboratorSuggestions,
  fetchPeriodFinancialSheet,
  fetchParameterSettings,
  fetchSquadsSuggestions,
  fetchUsers
} from "Thunks";
import TTPFilterHorizontalBar from "../Common/filters/TTPFilterHorizontalBar";
import { parsePreference, viewDataBy } from "Utils";
import styles from "./PeriodFinancialSheet.local.scss";
import {
  CLIENT_TYPE_FILTER,
  CLIENT_CRM_TYPE_FILTER,
  CLIENT_GROUP_CRM_FILTER,
  DELETED_STATUS,
  SORT_TYPES,
  IS_ENTITY_ALL,
  NEW_COLLABORATOR_ROLE_FILTER
} from "Config";

class PeriodFinancialSheetFilter extends Component {
  constructor(props) {
    super(props);
    this.sortOptions = Object.keys(SORT_TYPES).map(roleType => {
      return {
        label: _(roleType),
        options: SORT_TYPES[roleType].map(({ value, label }) => {
          return { label: _(label), value: value };
        })
      };
    });
    // this.loadClientSuggestions = debounce(this.loadClientSuggestions, 1000);
    this.loadCollaboratorSuggestions = debounce(
      this.loadCollaboratorSuggestions,
      1000
    );
    this.loadSquadSuggestions = debounce(this.loadSquadSuggestions, 1000);
    this.loadClusterSuggestions = debounce(this.loadClusterSuggestions, 1000);
    this.loadBusinessUnitSuggestions = debounce(
      this.loadBusinessUnitSuggestions,
      1000
    );
    this.handleSearchInputChange = debounce(this.handleSearchInputChange, 1000);

    this.state = {
      expandedYearsDiv: false,
      partner: this.props.user.id,
      collaboratorOptions: [],
      selectedKey: 0
    };
  }

  componentDidMount() {
    const { user, dispatch, preferences } = this.props;
    dispatch(fetchUsers());
    dispatch(
      setPartner(
        parsePreference(preferences.financial).financialState
          .allowViewDataBy === 11
          ? Number(user.id)
          : null
      )
    );
    document.addEventListener(
      "mousedown",
      this.handleClickOutsideYearsSelect.bind(this)
    );
  }

  componentDidUpdate(prevProps) {
    if (prevProps.partner !== this.props.partner) {
      this.setState({ selectedKey: this.state.selectedKey + 1 });
    }
  }

  setYearsWrapperRef(node) {
    this.wrapperYearsRef = node;
  }

  handleDisplayYearSelectItems = () => {
    let { expandedYearsDiv } = this.state;

    if (expandedYearsDiv === false) {
      this.setState({ expandedYearsDiv: true });
    } else {
      this.setState({ expandedYearsDiv: false });
    }
  };

  handleClickOutsideYearsSelect(event) {
    if (this.wrapperYearsRef && !this.wrapperYearsRef.contains(event.target)) {
      this.setState({ expandedYearsDiv: false });
    }
  }

  renderYearsLabel = () => {
    let { financialSheetFilter } = this.props;

    return financialSheetFilter.year.selected instanceof Array
      ? "2020"
      : financialSheetFilter.year.selected;
  };

  filterFormIsVisible = isVisible => {
    this.props.filterFormIsVisible(isVisible);
  };

  handleResetFilter = () => {
    // TODO
  };

  handleRefreshFinancialSheetTree = () => {
    this.props.dispatch(fetchPeriodFinancialSheet());
  };

  handleClientGroupChange = selected => {
    // let groups = selected.map(element => element.value);
    this.props.dispatch(setFilterClientGroup(selected));
    this.props.dispatch(initFilterClient());
    this.handleRefreshFinancialSheetTree();
  };

  handleGroupCRMClientChange = selected => {
    this.props.dispatch(setClientCRMGroup(selected));
    this.handleRefreshFinancialSheetTree();
  };

  handleClientChange = selected => {
    this.props.dispatch(setFilterClient(selected));
    this.handleRefreshFinancialSheetTree();
  };

  handleCollaboratorChange = selected => {
    // let collaborators = selected.map(element => element.value);
    const actifs = this.state.collaboratorOptions.filter(item => item.isActif);

    const combined = [...actifs, ...selected];
    const uniqueSelection = Array.from(
      new Map(combined.map(item => [item.value, item])).values()
    );

    this.props.dispatch(setFilterCollaborators(uniqueSelection));
    this.handleRefreshFinancialSheetTree();
  };

  handleYearsChange = selected => {
    this.setState(() => {
      this.props.dispatch(setFilterYear(selected));
      this.props.dispatch(fetchParameterSettings(selected));
      this.handleRefreshFinancialSheetTree();
    });
    this.setState({ expandedYearsDiv: false });
  };

  handlePartnerChange = selected => {
    const { partners, dispatch } = this.props;
    this.setState(() => {
      const partner = partners.find(partner => partner.id == Number(selected));
      dispatch(setPartnerZone(partner ? Number(partner.zone) : null));
      dispatch(setPartner(Number(selected)));
      this.handleRefreshFinancialSheetTree();
    });
  };

  handleSortChange = selected => {
    this.setState(() => {
      this.props.dispatch(setFinancialSortBy(selected));
      this.handleRefreshFinancialSheetTree();
    });
  };

  handleSquadChange = selected => {
    this.props.dispatch(setFilterSquads(selected));
    this.handleRefreshFinancialSheetTree();
  };

  handleClusterChange = selected => {
    this.props.dispatch(setFilterCluster(selected));
    this.handleRefreshFinancialSheetTree();
  };

  handleBusinessUnitChange = selected => {
    this.props.dispatch(setFilterBusinessUnit(selected));
    this.handleRefreshFinancialSheetTree();
  };

  handleSearchInputChange(word) {
    this.props.dispatch(setFinancialSheetTreeSearchWord(word));
    this.handleRefreshFinancialSheetTree();
  }

  handleTypeClientChange = selected => {
    this.props.dispatch(setClientType(selected));
    this.handleRefreshFinancialSheetTree();
  };

  handleTypeCRMClientChange = selected => {
    this.props.dispatch(setClientCRMType(selected));
    this.handleRefreshFinancialSheetTree();
  };

  handleSetIsEntityState = isEntity => {
    this.props.dispatch(setIsEntityClientsState(isEntity));
    this.handleRefreshFinancialSheetTree();
  };

  handleSetDeletedStatus = selectedStatus => {
    this.props.dispatch(setClientsDeletedStatus(selectedStatus));
    this.handleRefreshFinancialSheetTree();
  };

  handleRoleChange = selected => {
    this.props.dispatch(setRole(selected));
    this.handleRefreshFinancialSheetTree();
  };

  loadSquadSuggestions = (searchWord, callback) => {
    this.props
      .dispatch(fetchSquadsSuggestions(searchWord))
      .then(res => {
        const squads = res.value.data.data.map(t => {
          return {
            value: t.id,
            label: t.label,
            color: "#000000"
          };
        });
        callback(squads);
      })
      .catch(er => {
        callback([]);
      });
  };

  loadClusterSuggestions = (searchWord, callback) => {
    this.props
      .dispatch(fetchClusterSuggestions(searchWord))
      .then(res => {
        const clusters = res.value.data.data.map(t => {
          return {
            value: t.id,
            label: t.label,
            color: "#000000"
          };
        });
        callback(clusters);
      })
      .catch(er => {
        callback([]);
      });
  };

  loadBusinessUnitSuggestions = (searchWord, callback) => {
    this.props
      .dispatch(fetchBusinessUnitSuggestions(searchWord))
      .then(res => {
        const businessUnits = res.value.data.data.map(t => {
          return {
            value: t.id,
            label: t.label,
            color: "#000000"
          };
        });
        callback(businessUnits);
      })
      .catch(er => {
        callback([]);
      });
  };

  // loadClientSuggestions = (searchWord, callback) => {
  //   this.props
  //     .dispatch(fetchClientSuggestions(searchWord))
  //     .then(res => {
  //       let clientsList = res.value.data.data.filter(item => item !== null);
  //       const clients = clientsList.map(t => {
  //         return { value: t.id, label: t.name, color: "#000000" };
  //       });
  //       callback(clients);
  //     })
  //     .catch(er => {
  //       callback([]);
  //     });
  // };

  loadCollaboratorSuggestions = (searchWord, callback) => {
    const { preferences, collaborator, partner } = this.props;
    this.props
      .dispatch(fetchCollaboratorSuggestions(searchWord))
      .then(res => {
        const data = res.value.data.data;
        const list = viewDataBy(
          preferences.financial,
          data,
          collaborator,
          "financialState"
        );
        const collaborators = list.filter(item => item !== null).map(t => {
          return {
            value: t.id,
            label: t.name,
            partner: t.partner.value,
            isActif: t.isActif,
            color: "#000000"
          };
        });
        const options = partner
          ? collaborators.filter(c => c.partner === partner)
          : collaborators;
        this.setState({
          collaboratorOptions: options
        });
        callback(options);
      })
      .catch(er => {
        this.setState({
          collaboratorOptions: []
        });
        callback([]);
      });
  };

  renderYearsSelect = years => {
    const { expandedYearsDiv } = this.state;
    return (
      <div
        ref={this.setYearsWrapperRef.bind(this)}
        className={
          styles.customed_select +
          " " +
          (expandedYearsDiv === true ? styles.customed_select_opened : "")
        }
      >
        <div className={styles.customed_select_header}>
          <span>{this.renderYearsLabel()}</span>
          <div className={styles.year_actions}>
            <div>
              <span
                className={styles.year_action}
                onClick={this.handleDisplayYearSelectItems}
              >
                <i
                  className={
                    expandedYearsDiv === true
                      ? "icon icon-arrow-up"
                      : "icon icon-arrow-down"
                  }
                />
              </span>
            </div>
          </div>
        </div>
        {expandedYearsDiv === true && (
          <div className={styles.customed_select_body}>
            <div className={styles.customed_select_body_options}>
              {years.map((year, index) => (
                <div
                  key={index}
                  className={styles.customed_select_body_option}
                  onClick={() => this.handleYearsChange(year)}
                >
                  {year}
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    );
  };
  render() {
    let {
      financialSheetFilter,
      filter,
      resultCount,
      listFilters,
      partner,
      partners,
      loggedAs,
      preferences,
      collaborator
    } = this.props;
    let yearsOption = [];
    // let years =
    //   currentOrganization.startDate && currentOrganization.startDate.date
    //     ? renderYearsArrayBetween(
    //         currentOrganization.startDate.date,
    //         new Date(new Date().setFullYear(new Date().getFullYear() + 1))
    //       )
    //     : renderYearsArrayBetween(
    //         new Date(new Date().setFullYear(new Date().getFullYear() - 2)),
    //         new Date(new Date().setFullYear(new Date().getFullYear() + 1))
    //       );
    const currentYear = new Date().getFullYear();
    const years = Array.from(
      { length: currentYear - 2020 + 1 },
      (_, i) => 2020 + i
    );
    years.forEach(item => {
      yearsOption.push({ value: item.toString(), label: item.toString() });
    });

    let partnerOptions =
      partners &&
      partners.map(p => {
        return {
          label: p.name,
          value: p.id,
          zone: p.zone
        };
      });

    let filters = [
      {
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: true,
          placeholder: _("sortBy"),
          options: this.sortOptions,
          action: this.handleSortChange,
          values: financialSheetFilter.sortBy.selected
        }
      },
      {
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: false,
          isMulti: true,
          isClearable: true,
          placeholder: _("Groupe Client (CRM)"),
          options: CLIENT_GROUP_CRM_FILTER,
          values: filter.clientCRMGroup,
          action: this.handleGroupCRMClientChange
        }
      },
      {
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: false,
          isMulti: true,
          isClearable: true,
          placeholder: _("Type Client (CRM)"),
          options: CLIENT_CRM_TYPE_FILTER,
          values: filter.clientCRMTypes,
          action: this.handleTypeCRMClientChange
        }
      },
      {
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: false,
          isMulti: true,
          isClearable: true,
          placeholder: _("Type Client (Remarques)"),
          options: CLIENT_TYPE_FILTER,
          values: filter.clientTypes,
          action: this.handleTypeClientChange
        }
      },
      {
        grid: 3,
        type: "ASYNC_SELECT",
        options: {
          value: financialSheetFilter.squads.selected,
          placeholder: _("squad"),
          handleChange: this.handleSquadChange,
          loadSuggestions: this.loadSquadSuggestions,
          values: financialSheetFilter.squads.selected
        }
      },
      {
        grid: 3,
        type: "ASYNC_SELECT",
        options: {
          value: financialSheetFilter.cluster.selected,
          placeholder: _("Cluster"),
          handleChange: this.handleClusterChange,
          loadSuggestions: this.loadClusterSuggestions,
          values: financialSheetFilter.cluster.selected
        }
      },
      {
        grid: 3,
        type: "ASYNC_SELECT",
        options: {
          value: financialSheetFilter.businessUnit.selected,
          placeholder: _("BU"),
          handleChange: this.handleBusinessUnitChange,
          loadSuggestions: this.loadBusinessUnitSuggestions,
          values: financialSheetFilter.businessUnit.selected
        }
      },
      // {
      //   grid: 3,
      //   type: "ASYNC_SELECT",
      //   options: {
      //     value: financialSheetFilter.client.selected,
      //     key: financialSheetFilter.clientGroup.selected.length,
      //     placeholder: _("client"),
      //     handleChange: this.handleClientChange,
      //     loadSuggestions: this.loadClientSuggestions,
      //     values: financialSheetFilter.client.selected
      //   }
      // },
      {
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: true,
          isClearable: true,
          placeholder: _("clientType"),
          options: IS_ENTITY_ALL,
          values: filter.isEntity,
          action: this.handleSetIsEntityState
        }
      },
      {
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: true,
          isClearable: true,
          placeholder: _("clientState"),
          options: DELETED_STATUS,
          values: listFilters.entityClientId.deletedStatus,
          action: this.handleSetDeletedStatus
        }
      },
      {
        grid: 3,
        type: "ASYNC_SELECT",
        options: {
          key: this.state.selectedKey,
          value: financialSheetFilter.collaborator.selected,
          placeholder: _("collaborator"),
          handleChange: this.handleCollaboratorChange,
          loadSuggestions: this.loadCollaboratorSuggestions,
          values: financialSheetFilter.collaborator
        }
      }
    ];
    if (financialSheetFilter.collaborator.selected.length > 0) {
      delete NEW_COLLABORATOR_ROLE_FILTER.DELEGATED;
      filters.push({
        grid: 3,
        type: "SELECT",
        options: {
          isSimple: true,
          isClearable: true,
          placeholder: "Role",
          options: NEW_COLLABORATOR_ROLE_FILTER,
          values: filter.role,
          action: this.handleRoleChange
        }
      });
    }
    if (
      [1, 11].includes(
        parsePreference(preferences.financial).financialState.allowViewDataBy
      )
    ) {
      filters.unshift({
        type: "SELECT",
        options: {
          isSimple: true,
          isClearable: true,
          isSearch: true,
          isDisabled:
            parsePreference(preferences.financial).financialState
              .allowViewDataBy === 11,
          placeholder: _("partner"),
          options: partnerOptions,
          values:
            loggedAs === "COLLABORATOR" &&
            parsePreference(preferences.financial).financialState
              .allowViewDataBy === 11
              ? collaborator.partner.value
              : partner,
          action: this.handlePartnerChange
        }
      });
    }

    return (
      <div className="row align-center medium-12">
        <div className="medium-12">
          <TTPFilterHorizontalBar
            button
            filters={filters}
            nbResult={resultCount}
            marginLeft={"0.5em"}
            label={_("folderNumber")}
            customAddOn={this.renderYearsSelect(years)}
            handleResetFilter={this.handleResetFilter}
            searchPlaceholder="Search by name or erp id"
            searchInputValue={financialSheetFilter.searchWord.searchWord}
            handleSearchInputChange={this.handleSearchInputChange.bind(this)}
            filterFormIsVisible={this.filterFormIsVisible}
            cssClass="medium-12"
          />
        </div>
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  filter: state.financialSheet.periodTree.filter,
  resultCount: state.financialSheet.periodTree.resultCount,
  financialSheetFilter: state.financialSheet.periodFilter,
  listFilters: state.clients.filter,
  currentOrganization: state.auth.currentOrganization,
  user: state.auth.user,
  partners: state.auth.partnerOptions,
  partner: state.auth.partner,
  users: state.authorizations.items,
  loggedAs: selectLoggedAs(state),
  spaceAs: state.auth.spaceAs
});

export default connect(mapStateToProps)(PeriodFinancialSheetFilter);



// WEBPACK FOOTER //
// ./src/components/Financial/PeriodFinancialSheetFilter.js